import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-refund-modal',
  templateUrl: './refund-modal.component.html',
  styleUrls: ['./refund-modal.component.scss']
})
export class RefundModalComponent implements OnInit {
  @Input() modelId: any;
  @Input() modalName: string;
  @Input() loading: boolean;
  @Input() data: any;
  @Output() refundItem = new EventEmitter();

  constructor(
    private spinner: NgxSpinnerService,
  ) {
    console.log(this.data, 'data');
  }

  ngOnInit(): void {
    console.log(this.data, 'data');

    this.spinner.show()
  }


  onAction(action: string) {
    this.refundItem.emit(action)
  }
}
